import React from 'react';
import styled from 'styled-components';

import Section from '../../../../common/Section';

import Content from './header/Content';
import Images from './header/Images';

const Header = (props) => {
  const { app } = props;

  return (
    <StyledSection>
      <StyledHeader>
        <Content app={app} />
        {app.screenShots?.length > 0 && <Images images={app.screenShots} />}
      </StyledHeader>
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  background-color: var(--gray-light);
  padding-top: 125px;
  padding-bottom: 130px;
`;

const StyledHeader = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;

  @media ${({ theme }) => theme.xLargeUp} {
    flex-direction: row;
  }
`;

export default Header;
